export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-v1-960-34506e9e724676cb47a4a8b7595c4939.webp";